var _circle, _path, _rect, _rect2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "#00C853"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 30a12 12 0 0 1 24 0",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 30,
    width: 6,
    height: 12,
    rx: 3,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 30,
    width: 6,
    height: 12,
    rx: 3,
    fill: "#ffffff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 54,
    textAnchor: "middle",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#ffffff"
  }, "24/7")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport1);
export default __webpack_public_path__ + "static/media/support1.386c7055b8ca2748b8a9a54edbed4fc6.svg";
export { ForwardRef as ReactComponent };